import { FormsListPage } from 'app/components/paperwork/FormsListPage'
import { useFormsList } from 'app/components/paperwork/useFormsList'

export default function SettingsForms() {
  const props = useFormsList()
  return <FormsListPage {...props} />
}
